import { TableCell, TableHead, TableRow } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

import { usePasswordRecoveryList } from '../hooks/usePasswordRecoveryList';

export const PasswordRecoveryListTableHeader = () => {
  const { classes, columns } = usePasswordRecoveryList();

  return (
    <TableHead className={classes.root}>
      <TableRow>
        {columns.map((column) => (
          <TableCell key={column.name} align={column.align} width={column.colWidth ? column.colWidth : 'auto'}>
            <Font variant={'body2'} color={'textSecondary'}>
              <Text strong tId={column.label} />
            </Font>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
